import auth from './auth';

export const request = (method, url, body = null, binary = false, headers = null) => {
  const config = {
    method,
    headers: headers || {
      'Content-Type': 'application/json',
    },
  };
  if (body) {
    config.body = binary ? body : JSON.stringify(body)
  }
  return auth.fetch(url, config)
};

export const requestBinary = async (method, url, data, isBinary = false, token) => {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `JWT ${token}`,  // Add JWT token to headers
  };

  const options = {
    method,
    headers,
    body: JSON.stringify(data), // Serialize the payload to JSON
  };

  if (isBinary) {
    options.responseType = 'blob'; // Ensure binary response handling
  }

  const response = await fetch(url, options);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return isBinary ? await response.blob() : await response.json();
};

export const get = (url) => auth.fetch(url);

export const post = (url, body) => request('POST', url, body);

export const put = (url, body) => request('PUT', url, body);

export const patch = (url, body) => request('PATCH', url, body);

export const rDelete = (url) => request('DELETE', url);

export const uploadFile = (url, filename, file) => request('PUT', url, file, true, {
  'Content-Disposition': `attachment; filename="${encodeURI(filename)}"`,
});
